import { z } from 'zod';

import { QrpcCallDirection, QrpcContact, QrpcInput, QrpcResult } from '../loan/Qrpc';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const LogCallEvent = BaseLoanEvent.extend({
  type: z.literal('logCall'),
  contact: QrpcContact,
  date: zodDateOrString,
  result: QrpcResult,
  callDirection: QrpcCallDirection,
  callNotes: z.string().optional(),
  qrpc: QrpcInput.optional(),
  comment: z.string().optional(),
});
export type LogCallEvent = z.infer<typeof LogCallEvent>;
